import React, { Component } from 'react';
import './DynamicTable.css';
import moment from 'moment';
import PlanModal from './PlanModal';




class ReportTable extends Component {



  render() {

    const { headerData, planList } = this.props;

    let data;
    let noData;



    if (this.props.tableData && this.props.tableData.length > 0) {

      switch (this.props.dataType) {
        case 'revenue':
          data = this.props.tableData.map((entry) => (


            <tr>
              <td>{moment(entry.created_at).format('DD-MM-YYYY')}</td>
              <td>{entry.total_revenue / 100}</td>
              <td>{(entry.total_revenue_till_date) ? entry.total_revenue_till_date / 100 : '-'}</td>
            </tr>

          ))
          break;
        case 'plans':
          data = this.props.tableData.map((entry) => (
            <tr>
              <td style={{ 'fontSize': '14px' }}>{moment(entry.created_at).format('DD-MM-YYYY')}</td>
              <PlanTableHeader data={entry} />
            </tr>
          ))
          break;
        case 'numbers':
          data = this.props.tableData.map((entry) => (
            <tr>
              <td><PlanModal date={moment(entry.created_at).format('DD-MM-YYYY')} data={entry} /></td>
              <td>{entry.default}</td>
              <td>{entry.similar}</td>
              <td>{entry.premium}</td>
              <td>{entry.vip}</td>
            </tr>


          ))


          break;
      }
    } else {
      noData = <h6 style={{ 'padding': '20px', 'textAlign': 'center' }}> no data found</h6>
    }

    function PlanTableHeader(entry) {
      delete entry.data.created_at;
      let head = Object.values(entry.data).map(item => (
        <td style={{ 'padding': '4px' }}>{item}</td>
      ))
      return (
        <React.Fragment>
          {head}
        </React.Fragment>

      )
    }

    function TableHeader() {
      let head
      if (planList) {
        let data = [];
        for (let key in planList) {
          data.push(planList[key])
        }
        data.unshift('Date');
        head = data.map((value) => (
          <th style={{ 'fontSize': '14px', 'padding': '0px' }}>{value}</th>
        ))
      } else {
        head = headerData.map((value) => (
          <th style={{ 'fontSize': '14px' }}>{value}</th>
        ))
      }

      return (
        <thead>
          <tr>
            {head}
          </tr>
        </thead>
      )
    }



    return (
      <div>



        <table style={{ 'fontSize': '14px' }}>
          <TableHeader />


          {data}


        </table>
        {noData}
      </div>
    )
  }
}


export default ReportTable;
